module.exports = __webpack_public_path__ + "img/after-1.3a2bfd6f.png";